import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/shopmonkey.webp';
import screenshot_target from '../../../images/letterfunnel/michaelvanderheijden.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Michael van der Heijden"
      firstname="Michael"
      companyname="Shopmonkey"
      competition="Ask Phill en Flatline Agency"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/michaelvanderheijden.js